<script>
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
} from '@coreui/vue'

export default {
  components: {
    AppSidebar,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },

  data() {
    return {
      nav: [
        /*
        {
          name: 'My Home',
          url: '/',
          icon: 'icon-flag',
          badge: {
            variant: 'primary',
            text: 'Coming Soon',
          },
        },
        */
        {
          name: 'Home',
          url: '/',
          icon: 'icon-flag',
        },
        {
          title: true,
          name: 'Explore',
        },
        {
          name: 'Device',
          icon: 'icon-organization',
          children: [
            {
              name: 'State',
              icon: 'icon-organization',
              url: '/device/state',
            },
            {
              name: 'State History',
              icon: 'icon-organization',
              url: '/device/state/history',
            },
          ],
        },
        {
          divider: true,
        },
        {
          name: 'Insights',
          icon: 'icon-chemistry',
          children: [
            {
              name: 'Explorer',
              icon: 'icon-chemistry',
              url: '/insights/explorer',
            },
            {
              name: 'My Dashboards',
              icon: 'icon-chemistry',
              url: '/insights',
            },
          ],
        },
        {
          divider: true,
        },
        {
          name: 'My Actions',
          icon: 'icon-feed',
          url: '/actions',
        },
        {
          divider: true,
        },
        {
          name: 'Interact',
          icon: 'icon-notebook',

          children: [
            {
              name: 'Explorer',
              icon: 'icon-notebook',
              url: '/interact/',
            },
            {
              name: 'Activity',
              icon: 'icon-notebook',
              url: '/interact/activity',
            },
            {
              name: 'Cycle',
              icon: 'icon-notebook',
              url: '/interact/cycle',
            },
          ],
        },
        {
          divider: true,
        },
        {
          name: 'Settings',
          icon: 'icon-wrench',
          children: [
            {
              name: 'Device',
              icon: 'icon-wrench',
              children: [
                {
                  name: 'Setup',
                  icon: 'icon-settings',
                  url: '/settings/device',
                },
                {
                  name: 'Activities',
                  icon: 'icon-settings',
                  url: '/settings/device/activity',
                },
                {
                  name: 'Cycles',
                  icon: 'icon-settings',
                  url: '/settings/device/cycle',
                },
                {
                  name: 'Entity Descriptions',
                  icon: 'icon-settings',
                  url: '/settings/entitydescription',
                },
                {
                  name: 'Group',
                  icon: 'icon-settings',
                  url: '/settings/device/group',
                },
                {
                  name: 'Shift',
                  icon: 'icon-settings',
                  url: '/settings/device/shift',
                },
                {
                  name: 'Status',
                  icon: 'icon-settings',
                  url: '/settings/device/status',
                },
                {
                  name: 'Type',
                  icon: 'icon-settings',
                  url: '/settings/device/type',
                },
              ],
            },
            {
              name: 'Actions',
              icon: 'icon-wrench',
              url: '/settings/actions',
            },
            {
              name: 'Insights',
              icon: 'icon-wrench',
              children: [
                {
                  name: 'Access Tokens',
                  icon: 'icon-chemistry',
                  url: '/settings/analytics',
                },
              ],
            },
            {
              name: 'API',
              icon: 'icon-wrench',
              url: '/settings/api',
            },
            {
              name: 'Edge',
              icon: 'icon-wrench',
              url: '/settings/edge',
            },
            {
              name: 'Users',
              icon: 'icon-wrench',
              url: '/settings/users',
            },
          ],
        },
        {
          divider: true,
        },
      ],
    }
  },
}
</script>

<template>
  <AppSidebar v-once fixed>
    <SidebarHeader />
    <SidebarForm />
    <SidebarNav
      class="font-weight-bold text-uppercase text-muted"
      :nav-items="nav"
    ></SidebarNav>
    <SidebarFooter />
    <SidebarMinimizer />
  </AppSidebar>
</template>

<style lang="scss">
.sidebar .nav-link .nav-icon {
  font-size: 1.3rem !important;
}
.sidebar .nav-link {
  color: #666666 !important;
}
.sidebar .nav-item:hover > .nav-link {
  color: #cccccc !important;
}
</style>
